/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NoteVo } from './NoteVo';
import {
    NoteVoFromJSON,
    NoteVoFromJSONTyped,
    NoteVoToJSON,
    NoteVoToJSONTyped,
} from './NoteVo';

/**
 * 
 * @export
 * @interface ResponseNoteVo
 */
export interface ResponseNoteVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseNoteVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseNoteVo
     */
    message?: string;
    /**
     * 
     * @type {NoteVo}
     * @memberof ResponseNoteVo
     */
    data?: NoteVo;
}

/**
 * Check if a given object implements the ResponseNoteVo interface.
 */
export function instanceOfResponseNoteVo(value: object): value is ResponseNoteVo {
    return true;
}

export function ResponseNoteVoFromJSON(json: any): ResponseNoteVo {
    return ResponseNoteVoFromJSONTyped(json, false);
}

export function ResponseNoteVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseNoteVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : NoteVoFromJSON(json['data']),
    };
}

export function ResponseNoteVoToJSON(json: any): ResponseNoteVo {
    return ResponseNoteVoToJSONTyped(json, false);
}

export function ResponseNoteVoToJSONTyped(value?: ResponseNoteVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': NoteVoToJSON(value['data']),
    };
}

